<template>
    <div class="xl:mt-1/20 lg:mt-auto">
        <div class="flex items-center justify-center">
            <illustration name="error404" />
        </div>
        <div class="flex items-center justify-center mt-15">
            <router-link :to="{ name: 'Dashboard' }">
                <action-button 
                    border-color="border-transparent"
                    text-color="text-white"
                    bg-color="bg-pink-600"
                    bg-color-square="bg-pink-600"
                    icon-color="text-white"
                    libelle="Revenir à l'accueil"
                    :uppercase="true"
                    icon="home"
                    :enable-action="false"
                />
            </router-link>
        </div>
    </div>
</template>

<script>
import ActionButton from './../components/ActionButton';
import Illustration from './../components/Illustration';
export default {
  components:{
    Illustration,
    ActionButton,
  }
};
</script>